import { Component } from "react";

class CountUpTimer extends Component {
    constructor(props) {
        super();

        this.state = {
            timer: props.timer,
            intervalRef: null
        }
    }

    componentDidMount() {
        if (this.props.startTimer) {
            this.startTimer();
        } else if (this.props.stopTimer) {
            this.stopTimer();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.timer) {
            this.setState({
                timer: nextProps.timer
            });
        }

        if (nextProps.startTimer) {
            this.startTimer();
        } else if (nextProps.stopTimer) {
            this.stopTimer();
        }
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalRef);
    }

    startTimer() {
        if (this.state.intervalRef) {
            clearInterval(this.state.intervalRef);
        }

        const intervalRef = setInterval(() => {
            this.setState({
                timer: this.state.timer + 1
            });
        }, 1000);

        this.setState({
            intervalRef: intervalRef
        });
    }

    stopTimer() {
        clearInterval(this.state.intervalRef);
        this.props.onStopTimer(this.state.timer);
        this.setState({
            timer: 0
        });
    }

    formatNumber(number) {
        if (typeof number === "number") {
            return number.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping:false });
        }

        return number;
    }

    getTimeInString(timer) {
        const seconds = this.formatNumber(Math.floor(timer % 3600 % 60));
        const minutes = this.formatNumber(Math.floor(timer % 3600 / 60));
        const hours = this.formatNumber(Math.floor(timer / 3600));

        return <div className="row text-white">
                <div className="mt-m">
                    <div className="row">{hours}</div>
                    <div className="row justify-content-center fs-s">hh</div>
                </div><div className="mb-s">:</div>
                <div className="mt-m">
                    <div className="row">{minutes}</div>
                    <div className="row justify-content-center fs-s">mm</div>
                </div><div className="mb-s">:</div>
                <div className="mt-m">
                    <div className="row">{seconds}</div>
                    <div className="row justify-content-center fs-s">ss</div>
                </div>
        </div>;
    }

    render() {
        return (
            <div>
                {this.getTimeInString(this.state.timer)}
            </div>
        );
    }
}

export default CountUpTimer;
